import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=317efc75&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('317efc75')) {
      api.createRecord('317efc75', component.options)
    } else {
      api.reload('317efc75', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=317efc75&", function () {
      api.rerender('317efc75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2g405pW6P39kO/JS/comp/ErrorMessage.vue"
export default component.exports